import {
  LOGIN_REQUEST,
  LOGIN_SUCCESSFUL,
  LOGIN_FAILED,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESSFUL,
  SET_AUTHENTICATED_WITH_KEYCLOAK,
  LOGOUT_FAILED,
  SESSION_MAX_AGE,
  SET_SESSION_EXPIRY,
  AUTH_FAILURE,
  RESET_LOCKOUT,
  INITIATE_PASSWORD_CHANGE,
  SET_USERNAME,
  AuthenticationActionType,
  SET_TOKENS,
  START_SPINNER,
  STOP_SPINNER,
  SET_FAILURE_MESSAGE,
} from "./types";

import { User, TokenData } from "../../types";

export const setFailureMessage = (
  message: string | null
): AuthenticationActionType => ({
  type: SET_FAILURE_MESSAGE,
  message,
});

export const startSpinner = (): AuthenticationActionType => ({
  type: START_SPINNER,
});

export const stopSpinner = (): AuthenticationActionType => ({
  type: STOP_SPINNER,
});

export const fetchingAuthStatus = (): AuthenticationActionType => ({
  type: LOGIN_REQUEST,
});

export const setTokens = (tokenData: TokenData): AuthenticationActionType => ({
  type: SET_TOKENS,
  tokenData,
});

export const authFailure = (): AuthenticationActionType => ({
  type: AUTH_FAILURE,
});

export const loginSuccessful = (
  user: User,
  authenticatedWithKeycloak?: boolean
): AuthenticationActionType => ({
  type: LOGIN_SUCCESSFUL,
  user,
  authenticatedWithKeycloak,
});

export const setAuthenticatedWithKeycloak = (
  authenticatedWithKeycloak: boolean
): AuthenticationActionType => ({
  type: SET_AUTHENTICATED_WITH_KEYCLOAK,
  authenticatedWithKeycloak,
});

export const loginFailed = (message: string): AuthenticationActionType => ({
  type: LOGIN_FAILED,
  isFetching: false,
  isAuthenticated: false,
  message,
});

export const setInitiatePasswordChange = (): AuthenticationActionType => ({
  type: INITIATE_PASSWORD_CHANGE,
});

export const setUsername = (user: User): AuthenticationActionType => ({
  type: SET_USERNAME,
  user,
});

export const loggingOut = (): AuthenticationActionType => ({
  type: LOGOUT_REQUEST,
});

export const logoutSuccessful = (): AuthenticationActionType => ({
  type: LOGOUT_SUCCESSFUL,
});

export const logoutFailed = (message: string): AuthenticationActionType => ({
  type: LOGOUT_FAILED,
  message,
});

export const resetLockoutDuration = (): AuthenticationActionType => ({
  type: RESET_LOCKOUT,
});

export const setSessionMaxAge = (
  sessionTotalLength: number
): AuthenticationActionType => ({
  type: SESSION_MAX_AGE,
  sessionTotalLength,
});

export const setSessionExpiry = (
  sessionExpiry: string
): AuthenticationActionType => ({
  type: SET_SESSION_EXPIRY,
  sessionExpiry,
});
